var _a, _b, _c;
import { useCallback } from 'react';
import { SkillStatus } from '../../../constants/statuses';
import { useAppGoogleAnalytics } from '../../../../../../shared_app/hooks/useAppGoogleAnalytics';
import { SkillsReportEvents, useSkillsReportAnalytics, } from '../../../hooks/useSkillsReportAnalytics';
var HoverTeacherEventByStatus = (_a = {},
    _a[SkillStatus.NoData] = SkillsReportEvents.diagramsPieChartTbdHover,
    _a[SkillStatus.HelpNeeded] = SkillsReportEvents.diagramsPieChartHelpNeededHover,
    _a[SkillStatus.Developing] = SkillsReportEvents.diagramsPieChartDevelopingHover,
    _a[SkillStatus.Mastered] = SkillsReportEvents.diagramsPieChartMasteredHover,
    _a);
var HoverSupervizorEventByStatus = (_b = {},
    _b[SkillStatus.NoData] = 'skill_report_diagrams_hover_grey_supervizor',
    _b[SkillStatus.HelpNeeded] = 'skill_report_diagrams_hover_red_supervizor',
    _b[SkillStatus.Developing] = 'skill_report_diagrams_hover_yellow_supervizor',
    _b[SkillStatus.Mastered] = 'skill_report_diagrams_hover_green_supervizor',
    _b);
var TeacherClickEventByStatus = (_c = {},
    _c[SkillStatus.NoData] = SkillsReportEvents.diagramsTBDStudentClick,
    _c[SkillStatus.HelpNeeded] = SkillsReportEvents.diagramsHelpNeededStudentClick,
    _c[SkillStatus.Developing] = SkillsReportEvents.diagramsDevelopingStudentClick,
    _c[SkillStatus.Mastered] = SkillsReportEvents.diagramsMasteredStudentClick,
    _c);
var useSkillsSummaryAnalytics = function () {
    var ga = useAppGoogleAnalytics();
    var sendGaEvent = useSkillsReportAnalytics();
    var onBarHover = useCallback(function () {
        sendGaEvent(SkillsReportEvents.diagramsBarHover);
        ga === null || ga === void 0 ? void 0 : ga.sendEventAsSupervizor({
            action: 'skill_report_diagrams_hover_supervizor',
            category: 'Skills Report',
        });
    }, [ga, sendGaEvent]);
    var onPieChartHover = useCallback(function () {
        sendGaEvent(SkillsReportEvents.diagramsPieChartHover);
    }, [sendGaEvent]);
    var onPartHover = useCallback(function (status) {
        sendGaEvent(HoverTeacherEventByStatus[status]);
        ga === null || ga === void 0 ? void 0 : ga.sendEventAsSupervizor({
            action: HoverSupervizorEventByStatus[status],
            category: 'Skills Report',
        });
    }, [ga, sendGaEvent]);
    var onArrowClick = useCallback(function () {
        sendGaEvent(SkillsReportEvents.diagramsArrowClick);
        ga === null || ga === void 0 ? void 0 : ga.sendEventAsSupervizor({
            action: 'skill_report_diagrams_arrow_supervizor',
            category: 'Skills Report',
        });
    }, [ga, sendGaEvent]);
    var onTooltipHover = useCallback(function () {
        sendGaEvent(SkillsReportEvents.diagramsTooltipHover);
        ga === null || ga === void 0 ? void 0 : ga.sendEventAsSupervizor({
            action: 'skill_report_diagrams_tooltip_hover_supervizor',
            category: 'Skills Report',
        });
    }, [ga, sendGaEvent]);
    var onTooltipLinkClick = useCallback(function (status) {
        sendGaEvent(TeacherClickEventByStatus[status]);
        ga === null || ga === void 0 ? void 0 : ga.sendEventAsSupervizor({
            action: 'skill_report_click_diagrams_tooltip_supervizor',
            category: 'Skills Report',
        });
    }, [ga, sendGaEvent]);
    return {
        onBarHover: onBarHover,
        onPieChartHover: onPieChartHover,
        onPartHover: onPartHover,
        onArrowClick: onArrowClick,
        onTooltipHover: onTooltipHover,
        onTooltipLinkClick: onTooltipLinkClick,
    };
};
export { useSkillsSummaryAnalytics };
